import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-dp-bottom-sheet-closer',
  standalone: true,
  imports: [],
  templateUrl: './dp-bottom-sheet-closer.component.html',
  styleUrl: './dp-bottom-sheet-closer.component.scss'
})
export class DpBottomSheetCloserComponent {
  @Output() closeClicked = new EventEmitter<void>();

  closedialog() {
    this.closeClicked.emit();
  }
}
